<template>
	<div class="login-container">
		<!-- 背景效果 -->
		<div class="login-background">
			<div class="bg-gradient-1"></div>
			<div class="bg-gradient-2"></div>
			<div class="bg-gradient-3"></div>
			<div class="bg-pattern"></div>
			<div class="floating-shapes">
				<div class="shape shape-1"></div>
				<div class="shape shape-2"></div>
				<div class="shape shape-3"></div>
				<div class="shape shape-4"></div>
				<div class="shape shape-5"></div>
			</div>
		</div>

		<div class="login-box">
			<div class="login-body">
				<!-- 左侧品牌区域 -->
				<div class="login-left">
					<div class="login-left-content">
						<div class="logo-container">
							<div class="logo-glow"></div>
							<div class="logo-icon"></div>
							<div class="brand-text">
								<div class="logo-text">{{ $getter('setting').value10 || '后台管理系统' }}</div>
								<div class="logo-tagline">PROFESSIONAL PLATFORM</div>
							</div>
						</div>
						
						<div class="brand-info">
							<p>高效 · 安全 · 专业</p>
						</div>
						
						<div class="feature-list">
							<div class="feature-item">
								<div class="feature-icon">
									<i class="el-icon-connection"></i>
								</div>
								<div class="feature-content">
									<h3>企业级安全防护</h3>
									<p>多层安全架构，实时威胁检测，7×24小时安全监控</p>
								</div>
							</div>
							<div class="feature-item">
								<div class="feature-icon">
									<i class="el-icon-cpu"></i>
								</div>
								<div class="feature-content">
									<h3>智能化数据管理</h3>
									<p>AI驱动的数据分类、加密和备份，确保数据完整性与可用性</p>
								</div>
							</div>
							<div class="feature-item">
								<div class="feature-icon">
									<i class="el-icon-user"></i>
								</div>
								<div class="feature-content">
									<h3>多维度权限控制</h3>
									<p>细粒度访问控制，基于角色的权限管理，审计日志全覆盖</p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 右侧登录表单 -->
				<div class="login-right">
					<div class="login-form-wrapper">
						<div class="form-header">
							<h2 class="login-title">欢迎登录</h2>
							<p class="login-subtitle">请使用您的账户登录系统</p>
						</div>

						<div class="form-container">
							<el-form autocomplete="on" label-position="left" :model="form" :rules="rules"
								ref="loginForm">
								<el-form-item prop="username">
									<label class="input-label">用户名 / 账号</label>
									<div class="input-wrapper">
										<el-input type="text" tabindex="1" ref="username" name="username"
											autocomplete="on" placeholder="请输入用户名或账号"
											v-model="form.username" size="large" @focus="inputFocus('username')"
											@blur="inputBlur('username')">
											<template #prefix>
												<i class="el-icon-user input-prefix-icon"></i>
											</template>
										</el-input>
										<div class="input-line"></div>
									</div>
								</el-form-item>

								<el-form-item prop="password">
									<label class="input-label">密码</label>
									<div class="input-wrapper">
										<el-input tabindex="2" show-password ref="password" name="password"
											autocomplete="on" placeholder="请输入密码"
											v-model="form.password" size="large" @focus="inputFocus('password')"
											@blur="inputBlur('password')" @keyup.enter.native="handleLogin">
											<template #prefix>
												<i class="el-icon-lock input-prefix-icon"></i>
											</template>
										</el-input>
										<div class="input-line"></div>
									</div>
								</el-form-item>
							</el-form>

							<div class="login-actions">
								<el-checkbox v-model="rememberPassword" class="remember-checkbox">
									<span>记住密码</span>
								</el-checkbox>
								<a href="#" class="forgot-password" @click.prevent="handleForgot">
									<span>忘记密码？</span>
								</a>
							</div>

							<el-button class="login-btn" type="primary" :loading="loading" @click="handleLogin">
								<i class="el-icon-s-promotion btn-icon"></i>
								<span class="btn-text">{{ loading ? '登录中...' : '登录系统' }}</span>
								<div class="btn-shine"></div>
							</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 页脚 -->
		<div class="login-footer">
			<div class="footer-content">
				<a href="https://beian.miit.gov.cn/" target="_blank">{{ $getter('setting').value3 }}</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Login",
		data() {
			return {
				form: {
					username: "",
					password: ""
				},
				rememberPassword: false,
				loading: false,
				rules: {
					username: [{
							required: true,
							message: '请输入账号',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 20,
							message: '账号长度在 3 到 20 个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					]
				}
			};
		},
		created() {
			this.checkLogin();
			this.loadRememberedAccount();
		},
		methods: {
			checkLogin() {
				if (this.$getter('AdminInfo').id) {
					this.getMenu();
				}
			},
			loadRememberedAccount() {
				// 检查是否有记住的账号和密码
				const rememberedAccount = localStorage.getItem('rememberedAccount');
				const rememberedPassword = localStorage.getItem('rememberedPassword');
				
				if (rememberedAccount) {
					this.form.username = rememberedAccount;
				}
				
				if (rememberedPassword) {
					this.form.password = rememberedPassword;
					this.rememberPassword = true;
				} else if (rememberedAccount) {
					// 如果只有记住账号，也默认勾选记住密码
					this.rememberPassword = true;
				}
			},
			handleLogin() {
				this.$refs.loginForm.validate((valid) => {
					if (!valid) {
						return false;
					}

					this.loading = true;

					// 处理记住密码逻辑
					if (this.rememberPassword) {
						localStorage.setItem('rememberedAccount', this.form.username);
						localStorage.setItem('rememberedPassword', this.form.password);
					} else {
						localStorage.removeItem('rememberedAccount');
						localStorage.removeItem('rememberedPassword');
					}

					this.$post('sys-admin-login', this.form).then(res => {
						if (res.extra.UserCheck) {
							this.$apimit.set(res.extra.UserCheck);
							this.$vuex('AdminInfo', res.data, true);
							this.$vuex('UserCheck', res.extra.UserCheck, true);
							this.getMenu();
						} else {
							this.loading = false;
							this.$notify.error({
								message: '请重新登陆'
							});
						}
					}).catch(err => {
						this.loading = false;
						this.$warning(err);
					});
				});
			},
			getMenu() {
				this.$get('sys-admin-menu').then(res => {
					this.loading = false;
					try {
						this.$vuex('menu', res.data, true);
						if (res.data[0].pid == 0 && res.data[0].component) {
							return this.$navto(res.data[0].component);
						} else {
							return this.$navto(res.data[0].children[0].component);
						}
					} catch (err) {
						this.$warning('登录失败');
					}
				}).catch(err => {
					this.loading = false;
					this.$warning(err);
				});
			},
			inputFocus(field) {
				const inputEl = this.$refs[field].$el.querySelector('.el-input__inner');
				const lineEl = this.$refs[field].$el.parentNode.querySelector('.input-line');
				inputEl.classList.add('focused');
				lineEl.classList.add('active');
			},
			inputBlur(field) {
				const inputEl = this.$refs[field].$el.querySelector('.el-input__inner');
				const lineEl = this.$refs[field].$el.parentNode.querySelector('.input-line');
				inputEl.classList.remove('focused');
				lineEl.classList.remove('active');
			},
			handleForgot() {
				this.$message.info('请联系系统管理员重置密码');
			},
		}
	};
</script>

<style lang="scss" scoped>
	// 定义主题颜色
	$primary-color: #2783fd;
	$primary-hover: #1a6fd9;
	$primary-light: rgba(39, 131, 253, 0.1);
	$primary-gradient: linear-gradient(135deg, #2783fd 0%, #4a9dfe 100%);
	$text-primary: #1e293b;
	$text-secondary: #64748b;
	$text-light: #94a3b8;
	$border-color: #e2e8f0;
	$bg-light: #f8fafc;
	$bg-white: #ffffff;
	$shadow-color: rgba(39, 131, 253, 0.15);

	.login-container {
		width: 100%;
		min-height: 100vh;
		display: flex;
		flex-direction: column;
		background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
		overflow: hidden;
		position: relative;
	}

	.login-background {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 0;

		.bg-gradient-1 {
			position: absolute;
			top: -20%;
			right: -10%;
			width: 60%;
			height: 60%;
			background: radial-gradient(circle, rgba(39, 131, 253, 0.08) 0%, transparent 70%);
			border-radius: 50%;
			animation: float 18s ease-in-out infinite;
			filter: blur(40px);
		}

		.bg-gradient-2 {
			position: absolute;
			bottom: -30%;
			left: -10%;
			width: 70%;
			height: 70%;
			background: radial-gradient(circle, rgba(39, 131, 253, 0.05) 0%, transparent 70%);
			border-radius: 50%;
			animation: float 22s ease-in-out infinite reverse;
			filter: blur(45px);
		}

		.bg-gradient-3 {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 40%;
			height: 40%;
			background: radial-gradient(circle, rgba(39, 131, 253, 0.03) 0%, transparent 70%);
			border-radius: 50%;
			animation: pulse 12s ease-in-out infinite;
			filter: blur(35px);
		}

		.bg-pattern {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background-image:
				radial-gradient(circle at 25% 25%, rgba(39, 131, 253, 0.02) 1px, transparent 1px),
				radial-gradient(circle at 75% 75%, rgba(39, 131, 253, 0.02) 1px, transparent 1px);
			background-size: 60px 60px;
			background-position: 0 0, 30px 30px;
			opacity: 0.3;
			animation: patternMove 50s linear infinite;
		}

		.floating-shapes {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;

			.shape {
				position: absolute;
				border-radius: 50%;
				animation-timing-function: ease-in-out;

				&.shape-1 {
					top: 15%;
					left: 8%;
					width: 30px;
					height: 30px;
					background: rgba(39, 131, 253, 0.15);
					animation: floatShape 20s infinite;
					filter: blur(2px);
				}

				&.shape-2 {
					top: 65%;
					right: 12%;
					width: 20px;
					height: 20px;
					background: rgba(39, 131, 253, 0.12);
					animation: floatShape 24s infinite reverse;
					filter: blur(1.5px);
				}

				&.shape-3 {
					bottom: 25%;
					left: 15%;
					width: 25px;
					height: 25px;
					background: rgba(39, 131, 253, 0.1);
					animation: floatShape 18s infinite;
					filter: blur(2px);
				}

				&.shape-4 {
					top: 35%;
					right: 20%;
					width: 18px;
					height: 18px;
					background: rgba(39, 131, 253, 0.08);
					animation: floatShape 22s infinite reverse;
					filter: blur(1px);
				}

				&.shape-5 {
					top: 80%;
					left: 85%;
					width: 16px;
					height: 16px;
					background: rgba(39, 131, 253, 0.06);
					animation: floatShape 26s infinite;
					filter: blur(1px);
				}
			}
		}
	}

	@keyframes float {

		0%,
		100% {
			transform: translate(0, 0) scale(1);
			opacity: 0.3;
		}

		33% {
			transform: translate(20px, -25px) scale(1.05);
			opacity: 0.5;
		}

		66% {
			transform: translate(-15px, 15px) scale(0.95);
			opacity: 0.4;
		}
	}

	@keyframes floatShape {

		0%,
		100% {
			transform: translate(0, 0) rotate(0deg);
		}

		25% {
			transform: translate(15px, -20px) rotate(90deg);
		}

		50% {
			transform: translate(-10px, 15px) rotate(180deg);
		}

		75% {
			transform: translate(20px, 10px) rotate(270deg);
		}
	}

	@keyframes pulse {

		0%,
		100% {
			transform: translate(-50%, -50%) scale(1);
			opacity: 0.2;
		}

		50% {
			transform: translate(-50%, -50%) scale(1.15);
			opacity: 0.4;
		}
	}

	@keyframes patternMove {
		0% {
			background-position: 0 0, 30px 30px;
		}

		100% {
			background-position: 60px 60px, 90px 90px;
		}
	}

	.login-box {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 20px;
		position: relative;
		z-index: 1;
		min-height: calc(100vh - 80px);
	}

	.login-body {
		width: 100%;
		max-width: 1100px;
		height: 700px; /* 添加固定高度 */
		display: flex;
		border-radius: 24px;
		overflow: hidden;
		box-shadow:
			0 20px 60px rgba(0, 0, 0, 0.08),
			0 0 0 1px rgba(255, 255, 255, 0.95),
			inset 0 1px 0 rgba(255, 255, 255, 0.5);
		background: $bg-white;
		position: relative;
		animation: slideUp 0.8s cubic-bezier(0.23, 1, 0.32, 1);
		
		.login-left {
			flex: 1.2;
			background: $primary-gradient;
			color: white;
			display: flex;
			align-items: flex-start; /* 改为顶部对齐 */
			justify-content: center;
			padding: 40px 35px; /* 减少内边距 */
			position: relative;
			overflow: hidden;
			height: 100%; /* 确保高度填满 */

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				background: 
					radial-gradient(circle at 20% 80%, rgba(255, 255, 255, 0.2) 0%, transparent 50%),
					radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
			}

			.login-left-content {
				width: 100%;
				height: 100%; /* 确保高度填满 */
				position: relative;
				z-index: 1;
				animation: fadeIn 1s ease-out;
				display: flex;
				flex-direction: column;

				.logo-container {
					display: flex;
					align-items: center;
					gap: 25px; /* 增加间距 */
					margin-bottom: 35px; /* 减少底部间距以向上移动 */
					margin-top: 10px; /* 添加顶部间距以对齐表单标题 */

					.logo-glow {
						position: absolute;
						width: 200px; /* 增大发光效果 */
						height: 200px;
						background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
						border-radius: 50%;
						animation: glowPulse 4s ease-in-out infinite;
						filter: blur(25px); /* 增加模糊度 */
						z-index: 0;
					}

					.logo-icon {
						width: 80px; /* 放大图标 */
						height: 80px;
						background: white;
						border-radius: 22px; /* 稍微增大圆角 */
						position: relative;
						display: flex;
						align-items: center;
						justify-content: center;
						box-shadow: 
							0 15px 30px rgba(0, 0, 0, 0.18),
							0 6px 15px rgba(0, 0, 0, 0.12);
						z-index: 1;
						transition: all 0.3s ease;

						&:hover {
							transform: translateY(-4px);
							box-shadow: 
								0 20px 40px rgba(0, 0, 0, 0.25),
								0 8px 20px rgba(0, 0, 0, 0.18);
						}

						&::before {
							content: '';
							position: absolute;
							width: 40px; /* 放大SVG图标 */
							height: 40px;
							background: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%232783fd"><path d="M12 2L4 5v6.09c0 5.05 3.41 9.76 8 10.91 4.59-1.15 8-5.86 8-10.91V5l-8-3zm3.97 14.41c-1.84 2.17-5.21 2.1-6.97-.07-2.18-2.72-.65-6.72 2.69-7.33.34-.06.63.27.51.6-.46 1.07-.2 2.36.71 3.29s2.23 1.17 3.29.71c.33-.12.66.17.6.51-.61 3.34-4.61 4.83-6.83 2.29z"/></svg>');
							background-size: contain;
							background-repeat: no-repeat;
						}
					}

					.brand-text {
						.logo-text {
							font-size: 36px; /* 增大字体 */
							font-weight: 800;
							color: white;
							text-shadow: 0 3px 10px rgba(0, 0, 0, 0.25); /* 增强阴影效果 */
							line-height: 1.2;
							letter-spacing: 0.8px; /* 增加字间距 */
						}

						.logo-tagline {
							font-size: 14px; /* 增大副标题字体 */
							color: rgba(255, 255, 255, 0.9); /* 提高对比度 */
							font-weight: 400;
							letter-spacing: 3px; /* 增加字间距 */
							margin-top: 8px; /* 增加上边距 */
							text-transform: uppercase;
						}
					}
				}

				.brand-info {
					margin-bottom: 30px; /* 减少间距 */
					text-align: center;

					p {
						font-size: 18px; /* 调整字体大小 */
						color: rgba(255, 255, 255, 0.95);
						animation: slideInRight 0.8s ease-out 0.2s both;
						line-height: 1.5;
						font-weight: 500;
						letter-spacing: 1.5px;
					}
				}

				.feature-list {
				    flex: 1;
				    overflow-y: auto;
				    padding-right: 10px;
				
				    .feature-item {
				        display: flex;
				        align-items: flex-start;
				        gap: 16px; /* 稍微增加间距 */
				        margin-bottom: 28px; /* 增加间距 */
				        animation: fadeInUp 0.8s ease-out 0.4s both;
				        padding: 14px 16px; /* 增加内边距 */
				        border-radius: 12px; /* 稍微增加圆角 */
				        background: rgba(255, 255, 255, 0.1);
				        backdrop-filter: blur(10px);
				        transition: all 0.3s ease;
				
				        &:hover {
				            background: rgba(255, 255, 255, 0.15);
				            transform: translateX(5px);
				        }
				
				        .feature-icon {
				            width: 34px; /* 放大图标容器 */
				            height: 34px;
				            background: white;
				            border-radius: 8px; /* 稍微增加圆角 */
				            display: flex;
				            align-items: center;
				            justify-content: center;
				            flex-shrink: 0;
				            margin-top: 2px; /* 稍微调整上边距 */
				            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); /* 增加阴影 */
				
				            i {
				                font-size: 16px; /* 稍微放大图标 */
				                color: $primary-color;
				            }
				        }
				
				        .feature-content {
				            flex: 1;
				            h3 {
				                font-size: 16px; /* 放大标题 */
				                font-weight: 600;
				                margin-bottom: 6px; /* 增加下边距 */
				                color: white;
				            }
				
				            p {
				                font-size: 13px; /* 放大描述文字 */
				                color: rgba(255, 255, 255, 0.85);
				                line-height: 1.5; /* 增加行高 */
				                margin: 0;
				                opacity: 0.9;
				            }
				        }
				
				        &:nth-child(2) {
				            animation-delay: 0.5s;
				        }
				
				        &:nth-child(3) {
				            animation-delay: 0.6s;
				        }
				    }
				}
			}
		}

		.login-right {
			flex: 1;
			padding: 50px 45px; /* 调整内边距 */
			display: flex;
			align-items: flex-start; /* 改为顶部对齐以匹配左侧 */
			justify-content: center; /* 居中内容 */
			background: $bg-white;
			animation: fadeIn 1s ease-out 0.3s both;

			.login-form-wrapper {
				width: 100%;
				max-width: 380px;
				margin-top: 20px; /* 增加顶部间距以对齐logo */

				.form-header {
					margin-bottom: 35px; /* 减少底部间距以向上移动 */

					.login-title {
						font-size: 32px;
						color: $text-primary;
						margin-bottom: 8px; /* 减少底部间距 */
						font-weight: 700;
						animation: slideInDown 0.8s ease-out;
						letter-spacing: 0.5px;
						line-height: 1.2;
						position: relative;
						padding-bottom: 12px;

						&::after {
							content: '';
							position: absolute;
							bottom: 0;
							left: 0;
							width: 55px;
							height: 3px;
							background: $primary-color;
							border-radius: 2px;
							animation: slideInLeft 0.8s ease-out 0.3s both;
						}
					}

					.login-subtitle {
						color: $text-secondary;
						margin-bottom: 0;
						font-size: 14px;
						animation: slideInDown 0.8s ease-out 0.1s both;
						line-height: 1.5;
						padding-top: 15px; /* 调整顶部间距 */
					}
				}

				.form-container {
					animation: fadeInUp 0.8s ease-out 0.2s both;

					.input-label {
						display: block;
						margin-bottom: 8px;
						color: $text-primary;
						font-weight: 600;
						font-size: 13px;
						letter-spacing: 0.3px;
					}

					.input-wrapper {
						position: relative;

						.input-line {
							position: absolute;
							bottom: 0;
							left: 0;
							width: 0;
							height: 2px;
							background: $primary-gradient;
							transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
							border-radius: 2px;
							box-shadow: 0 2px 8px $shadow-color;
							
							&.active {
								width: 100%;
							}
						}
					}

					.login-actions {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-bottom: 30px; /* 减少间距 */
						flex-wrap: wrap;
						gap: 8px;

						.remember-checkbox {
							:deep(.el-checkbox__label) {
								color: $text-primary;
								font-size: 13px;
								font-weight: 500;
							}
							
							:deep(.el-checkbox__inner) {
								border-color: $border-color;
								
								&:hover {
									border-color: $primary-color;
								}
							}
						}

						.forgot-password {
							color: $primary-color;
							text-decoration: none;
							font-size: 13px;
							font-weight: 500;
							transition: all 0.3s ease;
							position: relative;
							padding-bottom: 2px;

							&:hover {
								color: $primary-hover;
								transform: translateX(3px);

								&::after {
									width: 100%;
								}
							}

							&::after {
								content: '';
								position: absolute;
								bottom: 0;
								left: 0;
								width: 0;
								height: 1px;
								background: $primary-color;
								transition: width 0.3s ease;
							}
						}
					}

					.login-btn {
						width: 100%;
						height: 52px; /* 调整高度 */
						font-size: 15px;
						font-weight: 600;
						border-radius: 12px;
						background: $primary-gradient;
						border: none;
						box-shadow:
							0 6px 20px $shadow-color,
							inset 0 1px 1px rgba(255, 255, 255, 0.2);
						transition: all 0.4s cubic-bezier(0.23, 1, 0.32, 1);
						position: relative;
						overflow: hidden;

						.btn-icon {
							font-size: 16px;
							margin-right: 8px;
						}

						.btn-text {
							position: relative;
							z-index: 2;
							letter-spacing: 0.6px;
						}

						.btn-shine {
							position: absolute;
							top: 0;
							left: -100%;
							width: 100%;
							height: 100%;
							background: linear-gradient(90deg,
									transparent,
									rgba(255, 255, 255, 0.4),
									transparent);
							transition: left 0.8s ease;
						}

						&:hover {
							box-shadow:
								0 10px 30px rgba(39, 131, 253, 0.25),
								inset 0 1px 1px rgba(255, 255, 255, 0.3);
							transform: translateY(-2px);
							background: linear-gradient(135deg, #1a6fd9 0%, #3a8bfd 100%);

							.btn-shine {
								left: 100%;
							}
						}

						&:active {
							transform: translateY(-1px);
							box-shadow:
								0 4px 15px rgba(39, 131, 253, 0.2),
								inset 0 1px 1px rgba(255, 255, 255, 0.2);
						}

						&:disabled {
							transform: none;
							box-shadow: 0 4px 15px rgba(39, 131, 253, 0.1);
							opacity: 0.7;
						}
					}

					.signup-link {
						text-align: center;
						margin-top: 25px; /* 减少间距 */
						color: $text-secondary;
						font-size: 13px;
						font-weight: 400;

						a {
							color: $primary-color;
							text-decoration: none;
							font-weight: 600;
							margin-left: 5px;
							transition: all 0.3s ease;
							position: relative;
							padding-bottom: 2px;

							&:hover {
								color: $primary-hover;
								transform: translateX(3px);

								&::after {
									width: 100%;
								}
							}

							&::after {
								content: '';
								position: absolute;
								bottom: 0;
								left: 0;
								width: 0;
								height: 1px;
								background: $primary-color;
								transition: width 0.3s ease;
							}
						}
					}
				}
			}
		}
	}

	@keyframes slideUp {
		from {
			opacity: 0;
			transform: translateY(40px) scale(0.95);
		}

		to {
			opacity: 1;
			transform: translateY(0) scale(1);
		}
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}

		to {
			opacity: 1;
		}
	}

	@keyframes fadeInUp {
		from {
			opacity: 0;
			transform: translateY(20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes slideInLeft {
		from {
			opacity: 0;
			transform: translateX(-30px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes slideInRight {
		from {
			opacity: 0;
			transform: translateX(30px);
		}

		to {
			opacity: 1;
			transform: translateX(0);
		}
	}

	@keyframes slideInDown {
		from {
			opacity: 0;
			transform: translateY(-20px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	@keyframes glowPulse {

		0%,
		100% {
			opacity: 0.3;
			transform: scale(1);
		}

		50% {
			opacity: 0.5;
			transform: scale(1.08);
		}
	}

	.login-footer {
		padding: 20px;
		text-align: center;
		color: $text-light;
		font-size: 12px;
		position: relative;
		z-index: 1;
		animation: fadeIn 1s ease-out 0.5s both;

		.footer-content {
			a {
				color: $text-secondary;
				text-decoration: none;
				transition: all 0.3s ease;
				font-size: 13px;
				font-weight: 500;

				&:hover {
					color: $primary-color;
					text-decoration: underline;
				}
			}
		}
	}

	// 输入框样式优化
	:deep(.el-input__inner) {
		height: 52px;
		font-size: 14px;
		border-radius: 12px;
		border: 2px solid $border-color;
		background: $bg-light;
		transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
		padding-left: 48px !important;
		color: $text-primary;
		font-weight: 500;

		&:focus {
			border-color: $primary-color;
			background: $bg-white;
			box-shadow: 0 4px 15px $primary-light;
			transform: translateY(-1px);
		}

		&.focused {
			border-color: $primary-color;
			background: $bg-white;
		}

		&::placeholder {
			color: $text-light;
			font-weight: normal;
		}
	}

	:deep(.el-input__prefix) {
		left: 16px !important;
		color: $text-light;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20px;
		transition: color 0.3s ease;

		.input-prefix-icon {
			font-size: 18px;
		}
	}

	:deep(.el-input--prefix .el-input__inner) {
		padding-left: 48px !important;
	}

	// 响应式设计
	@media screen and (max-width: 1200px) {
		.login-body {
			max-width: 1000px;
			height: 650px; /* 调整高度 */
			
			.login-left {
				padding: 35px 30px;
				
				.login-left-content {
					.logo-container {
						margin-bottom: 30px;
						margin-top: 8px;
						
						.logo-icon {
							width: 75px;
							height: 75px;
						}
						
						.brand-text {
							.logo-text {
								font-size: 32px; /* 调整大屏幕下的字体大小 */
							}
							.logo-tagline {
								font-size: 13px; /* 调整副标题大小 */
							}
						}
					}
				}
			}
			
			.login-right {
				padding: 45px 40px;
				
				.login-form-wrapper {
					margin-top: 18px;
					
					.form-header {
						margin-bottom: 30px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 900px) {
		.login-body {
			flex-direction: column;
			max-width: 500px;
			height: auto; /* 恢复自适应高度 */
			min-height: 600px; /* 设置最小高度 */
			border-radius: 20px;
			margin: 20px auto;

			.login-left {
				padding: 30px 25px;
				flex: none;
				min-height: 300px; /* 设置最小高度 */
				align-items: center; /* 恢复居中 */

				.login-left-content {
					.logo-container {
						margin-bottom: 25px;
						margin-top: 0; /* 重置顶部间距 */

						.logo-icon {
							width: 65px; /* 调整中等屏幕下的图标大小 */
							height: 65px;
						}

						.brand-text {
							.logo-text {
								font-size: 28px; /* 调整字体大小 */
							}
							
							.logo-tagline {
								font-size: 12px; /* 调整副标题大小 */
								letter-spacing: 2.5px;
							}
						}
					}
					
					.brand-info {
						margin-bottom: 25px;
						
						p {
							font-size: 14px;
						}
					}
					
					.feature-list {
						.feature-item {
							padding: 10px 14px; /* 调整内边距 */
							margin-bottom: 20px; /* 调整间距 */
							
							.feature-icon {
								width: 30px; /* 调整图标大小 */
								height: 30px;
								
								i {
									font-size: 14px;
								}
							}
							
							.feature-content {
								h3 {
									font-size: 14px;
								}
								
								p {
									font-size: 12px;
								}
							}
						}
					}
				}
			}

			.login-right {
				padding: 35px 30px;
				align-items: center; /* 恢复居中 */
				
				.login-form-wrapper {
					margin-top: 0; /* 重置顶部间距 */
					
					.form-header {
						margin-bottom: 35px;
						
						.login-title {
							font-size: 26px;
						}
						
						.login-subtitle {
							font-size: 13px;
						}
					}
					
					.form-container {
						.input-wrapper {
							margin-bottom: 25px;
						}
						
						.login-btn {
							height: 48px;
							font-size: 14px;
						}
					}
				}
			}
		}

		.login-box {
			padding: 15px;
			min-height: calc(100vh - 60px);
		}
	}

	@media screen and (max-width: 480px) {
		.login-body {
			max-width: 100%;
			border-radius: 16px;
			margin: 10px;

			.login-left {
				padding: 25px 20px;
				min-height: 250px;
				
				.login-left-content {
					.logo-container {
						margin-bottom: 25px;
						
						.logo-icon {
							width: 55px; /* 调整小屏幕下的图标大小 */
							height: 55px;
						}
						
						.brand-text {
							.logo-text {
								font-size: 24px; /* 调整字体大小 */
							}
							.logo-tagline {
								font-size: 11px; /* 调整副标题大小 */
							}
						}
					}
				}
			}

			.login-right {
				padding: 25px 20px;
			}
		}
		
		:deep(.el-input__inner) {
			height: 48px;
			padding-left: 44px !important;
		}
		
		:deep(.el-input__prefix) {
			left: 14px !important;
		}
	}
</style>